import * as RadixTooltip from '@radix-ui/react-tooltip';
import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';

interface Props {
  children: React.ReactNode;
  label: string;
}

const MotionContent = motion(RadixTooltip.Content);

export function Tooltip({ children, label }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <RadixTooltip.Provider>
      <RadixTooltip.Root
        onOpenChange={setIsOpen}
        open={isOpen}
        delayDuration={0}
      >
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <AnimatePresence>
          {isOpen && (
            <RadixTooltip.Portal forceMount>
              <MotionContent
                initial={{ opacity: 0, y: 4, scale: 0.96 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                className="max-w-[12.5rem] rounded-md bg-newGray-900 px-2 py-1 text-center text-xs font-medium text-white shadow-lg will-change-transform"
                sideOffset={5}
              >
                {label}
              </MotionContent>
            </RadixTooltip.Portal>
          )}
        </AnimatePresence>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
}
